// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>13</span>&nbsp;&nbsp;For it was not an open enemy that reviled me,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for then I could have borne it;<br> </p> </div></div>";
// Exports
module.exports = code;